import type { FC } from 'react';
import { FOOTER_URL, BOOK_A_CALL_URL } from '../copy';

// Footer is overlaid in white onto the purple band at the bottom of the
// illustration — no separate paper-coloured strip. The parent positions
// this footer absolutely over the illustration; the colour and underline
// styling here assume that purple backdrop.
//
// `pdfDownloadPath` is per-industry, supplied by the parent page from config.
export const OnePagerFooter: FC<{ pdfDownloadPath: string }> = ({
  pdfDownloadPath,
}) => (
  <footer className="px-6 pb-3 text-center text-[13px] text-white/85 md:px-10 md:pb-4 md:text-[14px]">
    <div className="flex flex-col items-center gap-2 md:flex-row md:justify-center md:gap-6">
      <a
        href={FOOTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="border-b border-current text-current no-underline hover:text-white"
      >
        www.getunimo.com
      </a>
      <a
        href={pdfDownloadPath}
        target="_blank"
        rel="noopener noreferrer"
        className="print:hidden border-b border-current text-current no-underline hover:text-white"
      >
        Download PDF
      </a>
    </div>
    {/* Print-only line: spell out the Book-a-call URL in place of the
        floating CTA which is hidden on print. */}
    <p className="hidden print:block mt-2">
      Book a call: {BOOK_A_CALL_URL}
    </p>
  </footer>
);
